import { FaPlus, FaSearch, FaTimes, FaSave, FaEdit, FaTrash } from "react-icons/fa";
import { useState, useEffect } from "react";
import {
    Container,
    Card,
    Table,
    Button,
    Modal,
    Form,
    Row,
    Col,
    Spinner,
    InputGroup
} from 'react-bootstrap';
// import { db } from '../../services/firebaseConnection';
import { useFirebaseConnection } from "../../services/useFirebaseConnection";

import {
    collection,
    getDocs,
    setDoc,
    updateDoc,
    deleteDoc,
    doc
} from 'firebase/firestore';

export default function Equipamentos() {

    const [equipamentos, setEquipamentos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [currentEquipamentos, setCurrentEquipamentos] = useState(null);
    const [loading, setLoading] = useState(true);
    const { db } = useFirebaseConnection();


    const fetchEquipamentos = async () => {
        const snapshot = await getDocs(collection(db, 'equipamentos'));
        const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setEquipamentos(list);
    };

    useEffect(() => {
        fetchEquipamentos().then(() => setLoading(false));
        }, []);


    const handleSave = async (equipamentoData) => {
    try {
        // Normaliza o nome para usar como ID (opcional, mas recomendado)
        const normalizedId = equipamentoData.nome.trim().toLowerCase().replace(/\s+/g, '_');

        if (equipamentoData.id) {
            const equipamentoRef = doc(db, 'equipamentos', equipamentoData.id);
            await updateDoc(equipamentoRef, equipamentoData);
        } else {
            const equipamentoRef = doc(db, 'equipamentos', normalizedId);
            await setDoc(equipamentoRef, { ...equipamentoData, id: normalizedId });
        }

        await fetchEquipamentos();
        setShowModal(false);
        setCurrentEquipamentos(null);

    } catch (error) {
        console.error('Erro ao salvar plano:', error);
    }
};

    const handleEdit = (equipamento) => {
        setCurrentEquipamentos(equipamento);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Tem certeza que deseja excluir este plano?")) {
            await deleteDoc(doc(db, 'equipamentos', id));
            await fetchEquipamentos();
        }
    };

    const equipamentosFiltrados = equipamentos.filter(equipamento => {
        const termo = searchTerm.toLowerCase();
        return (
            equipamento.nome?.toLowerCase().includes(termo) ||
            equipamento.categoria?.toLowerCase().includes(termo) ||
            equipamento.localidade?.toLowerCase().includes(termo) ||
            equipamento.local?.toLowerCase().includes(termo)
        );
    });

 return (
   <Container fluid className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Gerenciamento de Equipamentos</h1>
        <Button 
          variant="primary" 
          onClick={() => {setShowModal(true)}}
        >
          <FaPlus className="me-2" /> Novo Equipamento
        </Button>
      </div>

    {/* Barra de pesquisa */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Row>
            <Col>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Buscar por nome, categoria, localidade, local..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>

    {loading ? (
        <div className="text-center">
            <Spinner animation="border" />
        </div>
    ) : (
        <Card className="shadow-sm">
            <Card.Body>
                <div className="table-responsive">
                    <Table  hover>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Categoria</th>
                                <th>Localidade</th>
                                <th>Local</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {equipamentosFiltrados.map(equipamento => (
                                <tr key={equipamento.nome}>
                                    <td>{equipamento.nome}</td>
                                    <td>{equipamento.categoria}</td>
                                    <td>{equipamento.localidade}</td>
                                    <td>{equipamento.local}</td>
                                    <td>
                                        {/* <Button
                                            variant="warning"
                                            size="sm"
                                            onClick={() => handleEdit(equipamento)}
                                            className="me-2"
                                        >
                                            <FaEdit />
                                        </Button> */}
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => handleDelete(equipamento.id)}
                                        >
                                            <FaTrash />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    )}      

    <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Body>
            <EquipamentoForm
                plano={currentEquipamentos}
                onSave={handleSave}
                onCancel={() => setShowModal(false)}
            />
        </Modal.Body>
    </Modal>

   </Container>
 );
}

function EquipamentoForm({ equipamento, onSave, onCancel }) {
    const [formData, setFormData] = useState({
        id: equipamento?.id || null,
        nome: equipamento?.nome || '',
        categoria: equipamento?.categoria || '',
        localidade: equipamento?.localidade || '',
        local: equipamento?.local || ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <Card className="mb-4 shadow-sm">
            <Card.Header as="h5">{equipamento ? 'Editar Equipamento' : 'Novo Equipamento'}</Card.Header>
            <Card.Body>
                <Form onSubmit={handleSubmit}> 
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nome do Equipamento</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="nome"
                                    value={formData.nome}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Categoria</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="categoria"
                                    value={formData.categoria}
                                    onChange={handleChange}
                                    required
                                    min={1}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Localidade</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="localidade"
                                    value={formData.localidade}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Local</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="local"
                                    value={formData.local}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={onCancel} className="me-2">
                            <FaTimes className="me-1" /> Cancelar
                        </Button>
                        <Button variant="success" type="submit">
                            <FaSave className="me-2" /> Salvar
                        </Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
}
